import { useTranslation } from 'react-i18next'

import { Switch, Text } from '@reveni-io/reveni-ui'

import DatePicker from '@/common/components/DatePicker/DatePicker'
import { toStoreDateString } from '@/common/helpers/dates'
import { getBlockVisibilityErrors } from '@/configuration/pages/ConfigurationPage/OrderTrackingPageConfiguration/TrackingPageEditorModal/helpers'

import VisibilityCriteriaSelector from './VisibilityCriteriaSelector/VisibilityCriteriaSelector'
import * as Styles from './styles'

const BlockVisibilitySection = ({
  visibility,
  timeZone,
  onChange,
  criteriaOptions,
  loadingCriteriaOptions,
  onGoToCriteria,
}) => {
  const { t } = useTranslation()

  const errors = getBlockVisibilityErrors(visibility)

  const handleToggleDate = event => onChange({ limitByDate: event.target.checked })

  const handleToggleCriteria = event => onChange({ limitByCriteria: event.target.checked })

  const handleChangeStartDate = value => onChange({ visible_from: value })

  const handleChangeEndDate = value => onChange({ visible_until: value })

  const handleChangeCriteria = visibilityCriterionIds => onChange({ visibility_criterion_ids: visibilityCriterionIds })

  return (
    <Styles.Container>
      <Text type="titleS">{t('Visibilidad')}</Text>
      <Text type="bodyMRegular">
        {t('Decide cuándo se publica este bloque y qué condiciones deben cumplirse para que aparezca.')}
      </Text>
      <Styles.Toggle>
        <Styles.ToggleHeader>
          <Text type="bodyMBold">{t('Limitar visibilidad por fecha')}</Text>
          <Switch checked={visibility.limitByDate} onChange={handleToggleDate} label="" />
        </Styles.ToggleHeader>
        <Styles.Helper type="bodySRegular">
          {t(
            visibility.limitByDate
              ? 'Este bloque solo se mostrará durante el rango de fechas seleccionado.'
              : 'Este bloque se mostrará siempre en la página de seguimiento del pedido.'
          )}
        </Styles.Helper>
      </Styles.Toggle>
      {visibility.limitByDate && (
        <Styles.DateLimit>
          <Styles.DateRow>
            <DatePicker
              value={toStoreDateString(visibility.visible_from, timeZone)}
              onChange={handleChangeStartDate}
              label={t('Fecha de inicio')}
              error={Boolean(errors.limitByDate)}
              fullWidth
              clearable
            />
            <DatePicker
              value={toStoreDateString(visibility.visible_until, timeZone)}
              onChange={handleChangeEndDate}
              label={t('Fecha de fin')}
              error={Boolean(errors.limitByDate)}
              fullWidth
              clearable
            />
          </Styles.DateRow>
          {errors.limitByDate && (
            <Styles.ErrorText type="bodySRegular">{t('Al menos un campo es obligatorio')}</Styles.ErrorText>
          )}
        </Styles.DateLimit>
      )}
      <Styles.Toggle>
        <Styles.ToggleHeader>
          <Text type="bodyMBold">{t('Limitar la visibilidad por criterios')}</Text>
          <Switch checked={visibility.limitByCriteria} onChange={handleToggleCriteria} label="" />
        </Styles.ToggleHeader>
        <Styles.Helper type="bodySRegular">
          {t(
            visibility.limitByCriteria
              ? 'Este bloque aparecerá si se cumple al menos una de las siguientes condiciones.'
              : 'Este bloque estará visible en todas las páginas de pedidos sin condiciones asignadas.'
          )}
        </Styles.Helper>
      </Styles.Toggle>
      {visibility.limitByCriteria && (
        <VisibilityCriteriaSelector
          selectedCriterionIds={visibility.visibility_criterion_ids}
          onChange={handleChangeCriteria}
          criteriaOptions={criteriaOptions}
          loading={loadingCriteriaOptions}
          onGoToCriteria={onGoToCriteria}
          error={Boolean(errors.limitByCriteria)}
        />
      )}
    </Styles.Container>
  )
}

export default BlockVisibilitySection
